const MEAL_DATETIME_NAME_RE = /^meal\s*[-–—]\s*\d{4}-\d{2}-\d{2}/i;
const ISO_DATETIME_RE = /^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2})?/;

export function isPlaceholderMealName(name?: string | null): boolean {
  const trimmed = name?.trim();
  if (!trimmed) return true;
  if (MEAL_DATETIME_NAME_RE.test(trimmed)) return true;
  if (ISO_DATETIME_RE.test(trimmed)) return true;
  if (/glucose\s*spike/i.test(trimmed)) return true;
  return false;
}

export function formatMealTypeLabel(mealType?: string | null): string {
  const type = mealType?.trim()?.replace(/_/g, " ");
  if (!type) return "";
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
}

export function joinMealItemNames(
  items?: Array<{ name?: string | null } | null> | null,
): string {
  if (!items?.length) return "";
  return items
    .map((item) => item?.name?.trim())
    .filter((name): name is string => Boolean(name))
    .join(", ");
}

export function firstMealItemName(
  items?: Array<{ name?: string | null; product_name?: string | null } | null> | null,
): string {
  if (!items?.length) return "";
  for (const item of items) {
    const name = item?.name?.trim() || item?.product_name?.trim();
    if (name) return name;
  }
  return "";
}

export interface ResolveMealDisplayNameOptions {
  mealName?: string | null;
  mealTitle?: string | null;
  productName?: string | null;
  mealType?: string | null;
  mealItems?: Array<{ name?: string | null; product_name?: string | null } | null> | null;
  fallback?: string;
}

export function resolveMealDisplayName({
  mealName,
  mealTitle,
  productName,
  mealType,
  mealItems,
  fallback = "Meal logged",
}: ResolveMealDisplayNameOptions): string {
  const name = mealName?.trim();
  if (name && !isPlaceholderMealName(name)) return name;

  const title = mealTitle?.trim();
  if (title && !isPlaceholderMealName(title)) return title;

  const product = productName?.trim();
  if (product && !isPlaceholderMealName(product)) return product;

  const primaryItem = firstMealItemName(mealItems);
  if (primaryItem && !isPlaceholderMealName(primaryItem)) return primaryItem;

  const typeLabel = formatMealTypeLabel(mealType);
  if (typeLabel) return typeLabel;

  return fallback;
}
